// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3ovXE","title":"Header_title__2oVDA","left":"Header_left__2NTM5","clinicName":"Header_clinicName__25rXE"};